// export const env="http://localhost:1337"

//production
export const env="https://offshore.mayship.com/api"